import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-gray" }
const _hoisted_2 = {
  key: 0,
  class: "min-h-screen overflow-x-hidden"
}
const _hoisted_3 = { class: "h-[50vh] max-h-[600px] relative bg-dark before:absolute before:top-0 before:left-0 before:h-full before:w-full before:z-10 before:opacity-60 before:bg-gradient-to-r before:from-primary before:to-secondary" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "max-w-[800px] before:w-[50vw] min-h-[calc(50vh+(50vh/6))] xl:mt-[calc(50vh/6*-1)] before:absolute relative z-10 before:right-1/2 before:top-0 before:block mx-auto px-4 before:h-full bg-white before:bg-white" }
const _hoisted_6 = { class: "max-w-[580px] relative z-10 mx-auto py-8 lg:py-16 xl:py-20" }
const _hoisted_7 = { class: "2xl:w-[280px] xl:w-[200px] xl:absolute xl:right-full xl:top-0 xl:mr-28 xl:pt-20" }
const _hoisted_8 = {
  key: 0,
  class: "block mb-2 text-secondary text-base"
}
const _hoisted_9 = { class: "mb-4 lg:mb-8" }
const _hoisted_10 = { class: "relative inline-flex mb-6" }
const _hoisted_11 = { class: "inline-flex flex-col items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex mb-3 w-6 h-6 bg-tertiary rounded-full" }, null, -1)
const _hoisted_13 = { class: "inline-flex self-start text-tertiary font-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "top-[9px] absolute left-1/2 w-full w-[150px] h-1.5 ml-3 bg-gradient-to-r from-tertiary to-white" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "top-[9px] absolute right-1/2 w-screen h-1.5 bg-tertiary" }, null, -1)
const _hoisted_16 = { class: "-mb-6" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["src", "width", "height"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  class: "max-w-[800px] pb-[130px] lg:pr-[110px] lg:translate-x-[110px] relative mx-auto p-4 w-full bg-gradient-to-r from-primary to-secondary lg:p-16 lg:pb-8"
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "absolute bottom-0 right-0 flex lg:static"
}
const _hoisted_24 = { class: "flex flex-col flex-grow items-end justify-center mr-4 text-tertiary leading-6 lg:mr-8 lg:text-lg lg:leading-6" }
const _hoisted_25 = {
  key: 0,
  class: "not-italic font-bold"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/quote.svg",
  width: "108",
  height: "77",
  loading: "lazy",
  class: "absolute bottom-5 left-5 opacity-20 lg:bottom-auto lg:left-auto lg:right-5 lg:top-5",
  alt: ""
}, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "max-w-[800px] lg:pr-[110px] lg:translate-x-[110px] mx-auto p-0 w-full bg-gradient-to-r from-primary to-secondary lg:p-8"
}
const _hoisted_30 = { class: "aspect-w-16 aspect-h-9 relative z-10" }
const _hoisted_31 = ["src"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/quote.svg",
  width: "108",
  height: "77",
  loading: "lazy",
  class: "absolute right-5 top-5 hidden opacity-20 lg:block",
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'Timeline' },
      class: "absolute z-20 right-6 top-6 flex items-center justify-center w-11 h-11 hover:text-dark text-white bg-secondary hover:bg-tertiary rounded transition lg:right-10 lg:top-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_icon, {
          name: "close",
          class: "text-2xl"
        })
      ]),
      _: 1
    }),
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("figure", _hoisted_3, [
            (_ctx.item.hero)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.item.hero.image_url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.rt(_ctx.item.hero.image_url),
                        width: "1600",
                        height: "600",
                        loading: "lazy",
                        class: "absolute left-0 top-0 w-full h-full grayscale object-cover",
                        alt: ""
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.category)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.rt(_ctx.category.title)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.rt(_ctx.item.title)), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.rt(_ctx.item.year)), 1)
                  ]),
                  _hoisted_14,
                  _hoisted_15
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.contents, (content, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_ctx.rt(content.type) === 'paragraph')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (content.text)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: `content-${index}`,
                                class: "mb-6 leading-7",
                                innerHTML: _ctx.rt(content.text)
                              }, null, 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_ctx.rt(content.type) === 'heading3')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (content.text)
                              ? (_openBlock(), _createElementBlock("h3", {
                                  key: `content-${index}`,
                                  class: "text-primary text-lg font-bold leading-7",
                                  innerHTML: _ctx.rt(content.text)
                                }, null, 8, _hoisted_18))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_ctx.rt(content.type) === 'image')
                          ? (_openBlock(), _createElementBlock("figure", {
                              key: `content-${index}`,
                              class: "ml-[-50vw] max-w-[100vw] mr-[-50vw] relative left-1/2 right-1/2 my-8 w-screen lg:my-16 xl:my-20"
                            }, [
                              (content.image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.rt(content.image.url),
                                    width: _ctx.rt(content.image.width),
                                    height: _ctx.rt(content.image.height),
                                    loading: "lazy",
                                    class: "max-w-[800px] mx-auto w-full",
                                    alt: ""
                                  }, null, 8, _hoisted_19))
                                : _createCommentVNode("", true),
                              (content.image.caption)
                                ? (_openBlock(), _createElementBlock("figcaption", {
                                    key: 1,
                                    class: "max-w-[800px] p-4 pb-0 mx-auto w-full leading-normal italic text-gray-500 text-center",
                                    innerHTML: _ctx.rt(content.image.caption)
                                  }, null, 8, _hoisted_20))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.rt(content.type) === 'quote')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: `content-${index}`,
                                class: "ml-[-50vw] max-w-[100vw] mr-[-50vw] relative left-1/2 right-1/2 my-8 w-screen lg:my-16 xl:my-20"
                              }, [
                                (content.text)
                                  ? (_openBlock(), _createElementBlock("blockquote", _hoisted_21, [
                                      (content.text)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 0,
                                            class: "mb-4 text-white text-2xl italic lg:mb-8 lg:text-3xl",
                                            innerHTML: _ctx.rt(content.text)
                                          }, null, 8, _hoisted_22))
                                        : _createCommentVNode("", true),
                                      (content.author)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                              (content.author.name)
                                                ? (_openBlock(), _createElementBlock("cite", _hoisted_25, _toDisplayString(_ctx.rt(content.author.name)), 1))
                                                : _createCommentVNode("", true),
                                              (content.author.title)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.rt(content.author.title)), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (content.author.image_url)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: _ctx.rt(content.author.image_url),
                                                  width: "110",
                                                  height: "130",
                                                  loading: "lazy",
                                                  class: "w-[110px] h-[130px] object-cover lg:absolute lg:bottom-0 lg:right-0",
                                                  alt: ""
                                                }, null, 8, _hoisted_27))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _hoisted_28
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.rt(content.type) === 'video')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: `content-${index}`,
                                  class: "ml-[-50vw] max-w-[100vw] mr-[-50vw] relative left-1/2 right-1/2 my-8 w-screen lg:my-16 xl:my-20"
                                }, [
                                  (content.video)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("iframe", {
                                            src: _ctx.rt(content.video),
                                            width: "800",
                                            height: "450",
                                            frameborder: "0",
                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                            allowfullscreen: ""
                                          }, null, 8, _hoisted_31)
                                        ]),
                                        (content.caption)
                                          ? (_openBlock(), _createElementBlock("figcaption", {
                                              key: 0,
                                              class: "max-w-[800px] p-4 pb-0 mx-auto w-full leading-normal italic text-white text-center",
                                              innerHTML: _ctx.rt(content.caption)
                                            }, null, 8, _hoisted_32))
                                          : _createCommentVNode("", true),
                                        _hoisted_33
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              _createVNode(_component_router_link, {
                to: { name: 'Timeline' },
                class: "inline-flex items-center self-start mt-10 px-4 h-11 hover:text-dark text-white bg-secondary hover:bg-tertiary rounded transition"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_icon, {
                    name: "arrow-left",
                    class: "mr-2 mt-0.5 text-xs"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.t('back_to_timeline')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}